<template>
  <div class="roots" v-if="cropData">
    <n-input-number
      :label="$t('num-roots')"
      :value="cropData.numRoots"
      min="1"
      max="30"
      @change="handleNumRootsChange" />
    <button class="button--create" @click="handleCreateClick">
      {{$t('editor.root.create')}}
    </button>
    <select multiple="1" size="4" name="roots" @change="handleSelectionChange">
      <option v-for="(current, index) in cropData.roots" :key="current.id" :selected="selection.roots.find((currentIndex) => index === currentIndex) !== null">
        {{current.name}}
      </option>
    </select>
  </div>
</template>

<style lang="scss" scoped>
.button--create {
  margin-bottom: 1rem;
}
</style>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import InputNumber from '@/components/InputNumber'

export default {
  components: {
    'n-input-number': InputNumber
  },
  computed: {
    ...mapState({
      cropData: (state) => state.crop.data,
      selection: (state) => state.editor.selection
    })
  },
  methods: {
    ...mapMutations({
      createRoot: 'crop/createRoot',
      setNumRoots: 'crop/setNumRoots'
    }),
    ...mapActions({
      select: 'editor/select'
    }),
    handleCreateClick (e) {
      this.createRoot()
    },
    handleNumRootsChange (e) {
      this.setNumRoots(e.target.valueAsNumber)
    },
    handleSelectionChange (e) {
      this.select({
        name: e.target.name,
        selection: Array.from(e.target.selectedOptions).map((option) => option.index)
      })
    }
  }
}
</script>
